import createYCloudIcon from '../createYCloudIcon';

/**
 * @component @name Parasol
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuNSAxMS4xMzQgMTguMTk2IDIxIiAvPgogIDxwYXRoCiAgICBkPSJNMjAuNDI1IDUuMjk5YTEwIDEwIDAgMCAwLTE2Ljk0MSA5Ljc4Yy4xODMuNTYzLjg0My43NzQgMS4zNTUuNDc4TDIwLjE2IDYuNzExYy41MTItLjI5Ni42Ni0uOTczLjI2NC0xLjQxMyIKICAvPgogIDxwYXRoIGQ9Ik0yMSAyMUgzIiAvPgo8L3N2Zz4K) - https://tianjianjun0727.github.io/ycloud-icons/icons/parasol
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/preact - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Parasol = createYCloudIcon('parasol', [
  ['path', { d: 'M12.5 11.134 18.196 21', key: 'gf58kt' }],
  [
    'path',
    {
      d: 'M20.425 5.299a10 10 0 0 0-16.941 9.78c.183.563.843.774 1.355.478L20.16 6.711c.512-.296.66-.973.264-1.413',
      key: 'znqfe4',
    },
  ],
  ['path', { d: 'M21 21H3', key: 'oafrgs' }],
]);

export default Parasol;
